import * as React from "react";

export default function useOnClickOutside(
    ref: React.RefObject<any>,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    handler: any,
): void {
    // TODO Fix Any
    React.useEffect(() => {
        const listener = (event: MouseEvent | TouchEvent) => {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }

            handler(event);
        };

        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);

        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [ref, handler]);
}
